module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"discountValue":"Valor do desconto","discountFormat":"Formato do desconto","formats":{"money":"Real (R$)","percentage":"Percentual (%)"}},"en-US":{"discountValue":"Discount value","discountFormat":"Discount format","formats":{"money":"Real (R$)","percentage":"Percentage (%)"}}}')
  delete Component.options._Ctor
}
